const lang_zh = {
    "webTitle": "TrusTfi",
    "a_heyueleixing": [
        "",
        "",
    ]
}
export default lang_zh
